import React from 'react';

const RecurrenceSelector = ({ 
  isRecurring, 
  recurrenceType, 
  recurrenceDays, 
  recurrenceEndDate,
  onChange 
}) => {
  
  const handleRecurringChange = (e) => {
    const checked = e.target.checked;
    onChange({
      isRecurring: checked,
      recurrenceType: checked ? 'weekly' : null,
      recurrenceDays: checked ? [] : null,
      recurrenceEndDate: null
    });
  };

  const handleTypeChange = (e) => {
    const type = e.target.value;
    let days = [];
    
    // Pre-configurar días según tipo
    switch(type) {
      case 'daily':
        days = [0, 1, 2, 3, 4, 5, 6]; // Todos los días
        break;
      case 'weekdays':
        days = [1, 2, 3, 4, 5]; // Lunes a Viernes
        break;
      case 'weekly':
      case 'biweekly':
      case 'monthly':
        days = []; // Se configurará con la fecha inicial
        break;
      case 'custom':
        days = []; // Usuario selecciona manualmente
        break;
      default:
        days = [];
    }
    
    onChange({
      isRecurring,
      recurrenceType: type,
      recurrenceDays: days,
      recurrenceEndDate
    });
  };

  const handleDayToggle = (dayNumber) => {
    const currentDays = recurrenceDays || [];
    let newDays;
    
    if (currentDays.includes(dayNumber)) {
      newDays = currentDays.filter(d => d !== dayNumber);
    } else {
      newDays = [...currentDays, dayNumber].sort();
    }
    
    onChange({
      isRecurring,
      recurrenceType,
      recurrenceDays: newDays,
      recurrenceEndDate
    });
  };

  const handleEndDateChange = (e) => {
    onChange({
      isRecurring,
      recurrenceType,
      recurrenceDays,
      recurrenceEndDate: e.target.value || null
    });
  };

  const daysOfWeek = [
    { number: 1, label: 'L', fullName: 'Lunes' },
    { number: 2, label: 'M', fullName: 'Martes' },
    { number: 3, label: 'X', fullName: 'Miércoles' },
    { number: 4, label: 'J', fullName: 'Jueves' },
    { number: 5, label: 'V', fullName: 'Viernes' },
    { number: 6, label: 'S', fullName: 'Sábado' },
    { number: 0, label: 'D', fullName: 'Domingo' }
  ];

  return (
    <div className="recurrence-selector">
      <div className="recurrence-toggle">
        <label className="checkbox-label-inline">
          <input
            type="checkbox"
            checked={isRecurring || false}
            onChange={handleRecurringChange}
          />
          <span className="checkbox-text">🔄 Evento Recurrente</span>
        </label>
      </div>

      {isRecurring && (
        <div className="recurrence-options">
          <div className="form-group">
            <label>Tipo de Recurrencia *</label>
            <select
              value={recurrenceType || 'weekly'}
              onChange={handleTypeChange}
              className="select-input"
              required
            >
              <option value="daily">📅 Diario (todos los días)</option>
              <option value="weekdays">💼 Días laborables (Lunes a Viernes)</option>
              <option value="weekly">📆 Semanal (mismo día de la semana)</option>
              <option value="biweekly">🔁 Quincenal (cada 2 semanas)</option>
              <option value="monthly">📊 Mensual (mismo día del mes)</option>
              <option value="custom">⚙️ Personalizado (días específicos)</option>
            </select>
          </div>

          {recurrenceType === 'custom' && (
            <div className="form-group">
              <label>Días de la Semana *</label>
              <div className="days-selector">
                {daysOfWeek.map(day => (
                  <button
                    key={day.number}
                    type="button"
                    className={`day-button ${(recurrenceDays || []).includes(day.number) ? 'selected' : ''}`}
                    onClick={() => handleDayToggle(day.number)}
                    title={day.fullName}
                  >
                    {day.label}
                  </button>
                ))}
              </div>
              <small className="helper-text">
                Selecciona los días en que se repetirá el evento
              </small>
            </div>
          )}

          {recurrenceType === 'weekly' && (
            <div className="info-box">
              ℹ️ El evento se repetirá cada semana el mismo día que la fecha inicial
            </div>
          )}

          {recurrenceType === 'biweekly' && (
            <div className="info-box">
              ℹ️ El evento se repetirá cada 2 semanas el mismo día que la fecha inicial
            </div>
          )}

          {recurrenceType === 'monthly' && (
            <div className="info-box">
              ℹ️ El evento se repetirá el mismo día de cada mes
            </div>
          )}

          <div className="form-group">
            <label>Fecha de Fin (Opcional)</label>
            <input
              type="date"
              value={recurrenceEndDate || ''}
              onChange={handleEndDateChange}
              className="date-input"
            />
            <small className="helper-text">
              Si se deja vacío, el evento se repetirá indefinidamente
            </small>
          </div>

          <div className="recurrence-summary">
            <strong>📋 Resumen:</strong>
            <p>
              {recurrenceType === 'daily' && 'Se repetirá todos los días'}
              {recurrenceType === 'weekdays' && 'Se repetirá de Lunes a Viernes'}
              {recurrenceType === 'weekly' && 'Se repetirá cada semana el mismo día'}
              {recurrenceType === 'biweekly' && 'Se repetirá cada 2 semanas'}
              {recurrenceType === 'monthly' && 'Se repetirá mensualmente'}
              {recurrenceType === 'custom' && (recurrenceDays && recurrenceDays.length > 0
                ? `Se repetirá los ${daysOfWeek.filter(d => recurrenceDays.includes(d.number)).map(d => d.fullName).join(', ')}`
                : 'Selecciona al menos un día'
              )}
              {recurrenceEndDate && ` hasta el ${new Date(recurrenceEndDate).toLocaleDateString('es-ES')}`}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecurrenceSelector;

